import * as React from 'react';
import * as classnames from 'classnames';
import { connect } from 'react-redux';

import { IApplicationState } from '../../../../../reducers';
import { QuestionTypesMap } from '@nexxt/common/questionTypes';
import { Notes } from '../../../../common/notes';
import { alertMessage } from '../../../../../constants/alertMessage';
import { ALERT_MESSAGE_TYPES } from '../../../../../interface/project.interface';
import {
    UilPen,
    UilSetting,
    UilExclamationTriangle
} from '@iconscout/react-unicons';
import ReactTooltip from 'react-tooltip';
import { Question } from '@nexxt/common/types';
import HelperTooltip from '../../../../common/HelperTooltip';

interface IBuilderHeaderProps {
    showAlert?: boolean;
    alertMessages?: any[];
    currentQuestion: Question;
    showQuestionSetting: boolean;
    isSettingBoxLayoutOpen: boolean;
    question?: Question | { title: string };
    disabled?: boolean;
    errorObject?: any;
    hideTitle?: boolean;
    setValue?: (keyName: string, value: string) => void;
    toggleSettingBoxLayout: () => void;
}

interface IBuilderHeaderState {
    isSettingBoxLayoutOpen: boolean;
    editingLabel: boolean;
}

class BuilderHeader extends React.Component<
    IBuilderHeaderProps,
    IBuilderHeaderState
> {
    static defaultProps = {
        showQuestionSetting: true
    };
    state = {
        editingLabel: false,
        isSettingBoxLayoutOpen: true
    };
    labelInputRef = React.createRef<HTMLInputElement>();
    render() {
        const {
            showAlert,
            alertMessages,
            currentQuestion,
            hideTitle,
            toggleSettingBoxLayout
        } = this.props;
        const questionTypeItem = QuestionTypesMap[currentQuestion.type];
        const { image: qtypeImageURL, name: qtypeName } = questionTypeItem;

        const renderAlertMessage = () => {
            let alerts;
            if (alertMessages?.length) {
                alerts = alertMessages.map((alert, i) => {
                    switch (alert.type) {
                        case ALERT_MESSAGE_TYPES.WARN:
                            return (
                                <Notes
                                    type={alert.type}
                                    key={`warn-note-${i}`}
                                    note={alert.message}
                                />
                            );
                        case ALERT_MESSAGE_TYPES.DANGER:
                            return (
                                <Notes
                                    type={alert.type}
                                    key={`danger-note-${i}`}
                                    note={alert.message}
                                />
                            );
                        default:
                            return (
                                <Notes
                                    type={alert.type}
                                    key={`warn-note-${i}`}
                                    note={alert.message}
                                />
                            );
                    }
                });
            } else {
                alerts = (
                    <Notes
                        type={ALERT_MESSAGE_TYPES.WARN}
                        note={alertMessage.GENERIC_DISABLE_WARNING}
                    />
                );
            }
            return alerts;
        };
        return (
            <>
                <div className="builder-header">
                    <span className="builder-header-qtype">
                        {qtypeName} Question
                    </span>
                    {!hideTitle ? (
                        <div className="builder-header-wrapper">
                            <div className="builder-header-title">
                                <img src={qtypeImageURL} />
                                <input
                                    ref={this.labelInputRef}
                                    style={{
                                        width: `${this.props?.question?.title?.length}ch`
                                    }}
                                    className="builder-header-title--input"
                                    autoFocus
                                    type="text"
                                    placeholder="Unique Question Label"
                                    onBlur={() =>
                                        this.setState({ editingLabel: false })
                                    }
                                    disabled={this.props.disabled}
                                    value={this.props?.question?.title || ''}
                                    onChange={(e) =>
                                        this.props.setValue(
                                            'title',
                                            e.target.value
                                        )
                                    }
                                    onFocus={() =>
                                        this.labelInputRef?.current?.select()
                                    }
                                />
                                {this.props.errorObject?.title && (
                                    <>
                                        <span className="builder-header-title--warning">
                                            <UilExclamationTriangle
                                                size={20}
                                                data-tip="custom show"
                                                data-for={`question-label-helper`}
                                                data-delay-show="500"
                                            />
                                        </span>
                                        <ReactTooltip
                                            className="tooltip"
                                            id={`question-label-helper`}
                                            ara-haspopup="true"
                                            effect="solid"
                                            place="top"
                                        >
                                            <span>
                                                {this.props.errorObject?.title}
                                            </span>
                                        </ReactTooltip>
                                    </>
                                )}
                                {this.props.setValue &&
                                    !this.props.disabled &&
                                    !this.state.editingLabel && (
                                        <span
                                            className={classnames(
                                                'builder-header-title-icon',
                                                {
                                                    disabled:
                                                        this.state.editingLabel
                                                }
                                            )}
                                            onClick={() => {
                                                this.setState({
                                                    editingLabel: true
                                                });
                                                this.labelInputRef?.current?.select();
                                            }}
                                        >
                                            <UilPen size={20} />
                                        </span>
                                    )}
                                {this.props.showQuestionSetting && (
                                    <span
                                        className="builder-header-title-icon"
                                        onClick={toggleSettingBoxLayout}
                                    >
                                        <UilSetting size={20} />
                                    </span>
                                )}
                            </div>
                        </div>
                    ) : null}
                </div>
                {!hideTitle && showAlert ? renderAlertMessage() : null}
            </>
        );
    }
}

const mapStateToProps = (store: IApplicationState) => {
    const {
        questionReducer: { currentQuestion }
    } = store;
    return {
        currentQuestion
    };
};

export default connect(mapStateToProps, null)(BuilderHeader);
